import { render } from "./ClSegmented.vue?vue&type=template&id=4641b980&scoped=true"
import script from "./ClSegmented.vue?vue&type=script&lang=js"
export * from "./ClSegmented.vue?vue&type=script&lang=js"

import "./ClSegmented.vue?vue&type=style&index=0&id=4641b980&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4641b980"]])

export default __exports__